import styled from '@emotion/styled/macro'

export const UserInputDropdown = styled.div`
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
  margin-top: 40px;
  position: absolute;
  width: 87.5%;
  z-index: 101;
  
&:focus {
  border: none;
}
`

export const UserInputDropdownContentWrapper = styled.div`
  max-height: 380px;
  overflow: auto;
`
